import axios from 'axios';
import {
  MONTHLY_ADDON_PLACEHOLDER,
  ADDON_PLANS,
  MAP_DIALER_ADDON_CHARGEBEE_ID,
  MULTI_DIALER_PER_UNIT_CHARGEBEE_ID,
  SINGLE_DIALER_PER_UNIT_CHARGEBEE_ID,
  MULTI_DIALER_MONTHLY_BUNDLE_CHARGEBEE_ID,
  SINGLE_DIALER_MONTHLY_BUNDLE_CHARGEBEE_ID,
  MULTI_DIALER_ANNUAL_BUNDLE_CHARGEBEE_ID,
  SINGLE_DIALER_ANNUAL_BUNDLE_CHARGEBEE_ID,
  MULTI_DIALER_CRM_PREMIER_CHARGEBEE_ID,
  STATUS_CANCELLED_PENDING,
  VALID_ADDON_STATUS_LIST,
  ADDON_LANDING_PAGES_MONTHLY,
  ADDON_LANDING_PAGES_ANNUAL,
  ADDON_LANDING_PAGES_ANNUAL_PER_UNIT,
  ADDON_LANDING_PAGES_MONTHLY_PER_UNIT,
  ADDON_LANDING_PAGES_ANNUAL_BUNDLE,
  ADDON_LANDING_PAGES_MONTHLY_BUNDLE,
  LANDING_PAGES_ANNUAL_COUPON,
  ADDON_LANDING_PAGES_MONTHLY_PROMOTE_AGENT,
  SINGLE_DIALER_MONTHLY_PROMOTE_AGENT_CHARGEBEE_ID,
  MULTI_DIALER_MONTHLY_PROMOTE_AGENT_CHARGEBEE_ID,
} from '@/Core/config/addons';

const plans = ADDON_PLANS;

const initialState = {
  error: '',
  addRegisterFeeAddonsError: null,
  hostURL: null,
  showAddPayment: false,
  showPageHosted: false,
  showPlans: false,
  showDetailPlanSelected: null,
  userHasPlan: true,
  planId: MONTHLY_ADDON_PLACEHOLDER,
  addonId: null,
  createAddonResponse: null,
  cancelAddonResponse: null,
  updateAddonResponse: null,
  showPaymentResult: false,
  errorPaymentResult: null,
  userAddons: null,
  isMonthlyBilling: false,
  landingPagesJWT: null,
  addRegisterFeeAddonsSuccess: false,
  setAddRegisterFeeAddonsError: null,
  chargebeeCustomer: null,
  updatePaymentMethodHostedPageURL: '',
  isRegisterFeeAddonsLoading: false,
};

export default {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    setHostPage(state, hostPage) {
      state.hostURL = hostPage;
    },
    setError(state, error) {
      state.error = error;
    },
    setAddRegisterFeeAddonsError(state, error) {
      state.addRegisterFeeAddonsError = error;
    },
    setShowAddPayment(state, isShow) {
      state.showAddPayment = isShow;
    },
    setShowPageHosted(state, isShow) {
      state.showPageHosted = isShow;
    },
    setShowPlans(state, isShow) {
      state.showPlans = isShow;
    },
    setShowDetailPlanSelected(state, isShow) {
      state.showDetailPlanSelected = isShow;
    },
    setPlan(state, planId) {
      state.planId = planId;
    },
    setAddon(state, addonId) {
      state.addonId = addonId;
    },
    setCreateAddonResponse(state, response) {
      state.createAddonResponse = response;
    },
    setCancelAddonResponse(state, response) {
      state.cancelAddonResponse = response;
    },
    setUpdateAddonResponse(state, response) {
      state.updateAddonResponse = response;
    },
    setShowPaymentResult(state, isShow) {
      state.showPaymentResult = isShow;
    },
    setErrorPaymentResult(state, error) {
      state.errorPaymentResult = error;
    },
    setUserAddons(state, payload) {
      state.userAddons = payload;
    },
    setCancelAddon(state, addonId) {
      const addon = state.userAddons.find(p => {
        return (
          p.id_item === MAP_DIALER_ADDON_CHARGEBEE_ID[addonId] ||
          [
            ADDON_LANDING_PAGES_MONTHLY,
            ADDON_LANDING_PAGES_ANNUAL,
            ADDON_LANDING_PAGES_ANNUAL_PER_UNIT,
            ADDON_LANDING_PAGES_MONTHLY_PER_UNIT,
            ADDON_LANDING_PAGES_ANNUAL_BUNDLE,
            ADDON_LANDING_PAGES_MONTHLY_BUNDLE,
            ADDON_LANDING_PAGES_MONTHLY_PROMOTE_AGENT,
          ].includes(p.id_item)
        );
      });
      addon.txt_status = STATUS_CANCELLED_PENDING;
      state = {
        state,
        ...addon,
      };
    },
    setUpdateAddon(state, { addonIdSelected, previousAddonId }) {
      const addon = state.userAddons.find(p => {
        return (
          p.id_item === MAP_DIALER_ADDON_CHARGEBEE_ID[previousAddonId] ||
          p.id_item === ADDON_LANDING_PAGES_MONTHLY ||
          p.id_item === ADDON_LANDING_PAGES_MONTHLY_PER_UNIT ||
          p.id_item === ADDON_LANDING_PAGES_MONTHLY_BUNDLE ||
          p.id_item === ADDON_LANDING_PAGES_MONTHLY_PROMOTE_AGENT
        );
      });
      addon.id_item = MAP_DIALER_ADDON_CHARGEBEE_ID[addonIdSelected];
      if (addonIdSelected === ADDON_LANDING_PAGES_ANNUAL_PER_UNIT) {
        addon.id_item = ADDON_LANDING_PAGES_ANNUAL_PER_UNIT;
      }

      state = {
        state,
        ...addon,
      };
    },
    toggleBillingLength(state, isMonthlyBilling) {
      state.isMonthlyBilling = isMonthlyBilling;
    },
    setLandingPagesJWT(state, jwt) {
      state.landingPagesJWT = jwt;
    },
    setAddRegisterFeeAddonsSuccess(state, boolean) {
      state.addRegisterFeeAddonsSuccess = boolean;
    },
    setChargebeeCustomer(state, customer) {
      state.chargebeeCustomer = customer;
    },
    setUpdatePaymentMethodHostedPage(state, hostedPage) {
      state.updatePaymentMethodHostedPageURL = hostedPage.url;
    },
    setIsRegisterFeeAddonsLoading(state, boolean) {
      state.isRegisterFeeAddonsLoading = boolean;
    },
  },
  getters: {
    getHostedUrl: state => {
      return state.hostURL;
    },
    planName: state => {
      if (!state.addonId) return '';
      return plans.find(({ id }) => id === state.addonId).planName;
    },
    userAddons: state => {
      return state.userAddons;
    },
    hasPlanStormDialer: state => {
      return (
        state.userAddons &&
        state.userAddons.find(p => {
          return (
            ([
              MULTI_DIALER_PER_UNIT_CHARGEBEE_ID,
              SINGLE_DIALER_PER_UNIT_CHARGEBEE_ID,
              MULTI_DIALER_MONTHLY_BUNDLE_CHARGEBEE_ID,
              SINGLE_DIALER_MONTHLY_BUNDLE_CHARGEBEE_ID,
              MULTI_DIALER_ANNUAL_BUNDLE_CHARGEBEE_ID,
              SINGLE_DIALER_ANNUAL_BUNDLE_CHARGEBEE_ID,
              MULTI_DIALER_CRM_PREMIER_CHARGEBEE_ID,
              SINGLE_DIALER_MONTHLY_PROMOTE_AGENT_CHARGEBEE_ID,
              MULTI_DIALER_MONTHLY_PROMOTE_AGENT_CHARGEBEE_ID,
            ].includes(p.id_item) ||
              ADDON_PLANS.find(q => MAP_DIALER_ADDON_CHARGEBEE_ID[q.id] === p.id_item)) &&
            VALID_ADDON_STATUS_LIST.includes(p.txt_status)
          );
        })
      );
    },
    landingPagesAddon: state => {
      if (!state.userAddons) return null;
      return state.userAddons.find(addon => {
        return (
          [
            ADDON_LANDING_PAGES_MONTHLY,
            ADDON_LANDING_PAGES_ANNUAL,
            ADDON_LANDING_PAGES_ANNUAL_PER_UNIT,
            ADDON_LANDING_PAGES_MONTHLY_PER_UNIT,
            ADDON_LANDING_PAGES_ANNUAL_BUNDLE,
            ADDON_LANDING_PAGES_MONTHLY_BUNDLE,
            ADDON_LANDING_PAGES_MONTHLY_PROMOTE_AGENT,
          ].includes(addon.id_item) && VALID_ADDON_STATUS_LIST.includes(addon.txt_status)
        );
      });
    },
    hasLandingPagesMonthly: state => {
      return (
        state.userAddons &&
        state.userAddons.find(
          addon =>
            addon.id_item === ADDON_LANDING_PAGES_MONTHLY ||
            addon.id_item === ADDON_LANDING_PAGES_MONTHLY_BUNDLE ||
            addon.id_item === ADDON_LANDING_PAGES_MONTHLY_PER_UNIT ||
            addon.id_item === ADDON_LANDING_PAGES_MONTHLY_PROMOTE_AGENT,
        )
      );
    },
    customerHasValidCC: state => {
      return state.chargebeeCustomer && state.chargebeeCustomer.card_status === 'valid';
    },
  },
  actions: {
    async resetErrorMessage({ commit }) {
      commit('setError', '');
    },
    async resetErrorPaymentResult({ commit }) {
      commit('setErrorPaymentResult', '');
    },
    async getUserAddons({ commit }) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_BILLING_API_BASE_URL}/addons`);
        commit('setUserAddons', response.data);
        return response.data;
      } catch (error) {
        commit('userError', error);
      }
    },
    // hostpage chargebee for load in iframe
    async getHostedNewPage({ commit }, { planId, addonId, couponId, trialDays }) {
      try {
        const payload = {
          plan_id: planId,
          addon_id: addonId,
          coupon_id: couponId,
          trial_days: trialDays.toString(),
          app_request: 'crm',
        };
        const response = await axios.post(
          `${process.env.VUE_APP_BILLING_API_BASE_URL}/new-user-card-form`,
          payload,
        );
        commit('setHostPage', response.data.url);
      } catch (error) {
        commit('setError', error.message);
      }
    },
    async addAddon({ commit, dispatch }, addonId) {
      try {
        const payload = {
          addon_type: addonId,
        };
        if (addonId === ADDON_LANDING_PAGES_ANNUAL_PER_UNIT) {
          payload.coupon_code = LANDING_PAGES_ANNUAL_COUPON;
        }
        const response = await axios.put(
          `${process.env.VUE_APP_BILLING_API_BASE_URL}/addons`,
          payload,
        );
        commit('setCreateAddonResponse', response.data);
        await dispatch('getUserAddons');
      } catch (error) {
        const errorMessage = 'Error: purchasing addon';
        commit('setShowPageHosted', false);
        commit('setError', errorMessage);
      }
    },
    async cancelAddon({ commit }, addonId) {
      try {
        const payload = {
          addon_type: addonId,
        };
        const response = await axios.put(
          `${process.env.VUE_APP_BILLING_API_BASE_URL}/addons/cancel`,
          payload,
        );
        commit('setCancelAddon', addonId);
        commit('setCancelAddonResponse', response.data);
      } catch (error) {
        commit('setError', error);
      }
    },
    async updateAddon({ commit }, { addonIdSelected, previousAddonId }) {
      try {
        const payload = {
          new_addon_type: addonIdSelected,
          previous_addon_type: previousAddonId,
          end_of_term: false,
        };
        const response = await axios.put(
          `${process.env.VUE_APP_BILLING_API_BASE_URL}/addons/update`,
          payload,
        );
        commit('setUpdateAddonResponse', response.data);
        commit('setUpdateAddon', { addonIdSelected, previousAddonId });
      } catch (error) {
        commit('setError', error);
      }
    },
    setShowPlans({ commit }, showPlans) {
      commit('setShowPlans', showPlans);
    },
    toggleBillingLength({ commit }, isMonthlyBilling) {
      commit('toggleBillingLength', isMonthlyBilling);
    },
    setShowAddPayment({ commit }, isShow) {
      commit('setShowAddPayment', isShow);
    },
    setAddon({ commit }, addonId) {
      commit('setAddon', addonId);
    },
    setShowPaymentResult({ commit }, isShow) {
      commit('setShowPaymentResult', isShow);
    },
    setShowDetailPlanSelected({ commit }, isShow) {
      commit('setShowDetailPlanSelected', isShow);
    },
    async getLandingPagesJWT({ commit }) {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_AUTHENTICATION_API_BASE_URL}/landing-pages-token`,
        );
        commit('setLandingPagesJWT', data.token);
      } catch (error) {
        commit('setError', error);
      }
    },
    async getChargebeeCustomer({ commit }) {
      try {
        const getRes = await axios.get(
          `${process.env.VUE_APP_BILLING_API_BASE_URL}/subscriptions/chargebee/customer`,
        );
        if (!getRes.data.id) {
          const createRes = await axios.post(
            `${process.env.VUE_APP_BILLING_API_BASE_URL}/subscriptions/chargebee/customer`,
          );
          return commit('setChargebeeCustomer', createRes.data);
        }
        commit('setChargebeeCustomer', getRes.data);
      } catch (error) {
        commit('setError', error);
      }
    },
    async getUpdatePaymentHostedPage({ commit }) {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_BILLING_API_BASE_URL}/subscriptions/chargebee/card/hosted-page`,
        );
        commit('setUpdatePaymentMethodHostedPage', data);
      } catch (error) {
        commit('setError', error);
      }
    },
    async addRegisterFeeAddons({ commit, state }, { isRetry, isBrandRetry,  isStandard }) {
      commit('setIsRegisterFeeAddonsLoading', true);
      try {
        const campaignMonthAddon = 'texting-suite-reg-campaign-2-monthly';
        const payload = {
          addons: ['texting-suite-reg-brand-19-onetime', campaignMonthAddon],
          chargebee_customer_id: state.chargebeeCustomer.id,
        };
        if (isStandard) {
          payload.addons = ['texting-suite-reg-standard-campaign-12-monthly', 'v2-standard-brand-registration', 'v2-standard-campaign-registration'];
        }
        if (isBrandRetry) {
          payload.addons = ['texting-suite-reg-brand-4-retry-onetime'];
        }
        if (isStandard && isBrandRetry) {
          payload.addons = ['texting-suite-reg-brand-44-retry-onetime'];
        }
        if (isRetry) {
          payload.addons = ['texting-suite-reg-campaign-15-retry-onetime'];
        }
        
        if (payload.addons.includes(campaignMonthAddon)) {
          payload.dont_allow_duplicates = true;
        }

        await axios.post(
          `${process.env.VUE_APP_BILLING_API_BASE_URL}/addons/twilio/10dlc-registration`,
          payload,
        );
        commit('setAddRegisterFeeAddonsSuccess', true);
        commit('setAddRegisterFeeAddonsError', null);
      } catch (error) {
        commit('setAddRegisterFeeAddonsError', error.data && error.data.error ? error.data.error : 'error in payment process');
      } finally {
        commit('setIsRegisterFeeAddonsLoading', false);
      }
    },
    setAddRegisterFeeAddonsSuccess({ commit }, boolean) {
      commit('setAddRegisterFeeAddonsSuccess', boolean);
    },
  },
};
